var _rect, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLoyaltyWatch = function SvgLoyaltyWatch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    stroke: "#121010",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 3.75,
    width: 12.5,
    height: 12.5,
    rx: 2.25,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16L2.62764 17.6946C2.91823 18.4792 3.66647 19 4.50314 19L9.49686 19C10.3335 19 11.0818 18.4792 11.3724 17.6946L12 16",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L11.3724 2.30537C11.0818 1.52079 10.3335 1 9.49686 1L4.50314 1C3.66647 1 2.91823 1.52079 2.62764 2.30537L2 4",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76716 7L4.84314 7.9H3.10172L2.1777 7H5.76716ZM5.76716 13H2.1777L3.10172 12.1086H4.84314L5.76716 13ZM2.92402 10.7286V11.9371L2 12.8286V10.5057L2.34651 10.1714L2.92402 10.7286ZM2 9.49429V7.17143L2.92402 8.06286V9.27143L2.34651 9.83714L2 9.49429ZM5.93597 10.5057V12.8286L5.01195 11.9371V10.7286L5.58947 10.1714L5.93597 10.5057ZM5.01195 9.27143V8.06286L5.93597 7.17143V9.49429L5.58947 9.83714L5.01195 9.27143ZM4.95864 9.55429L5.42065 10L4.95864 10.4457H2.98621L2.5242 10L2.98621 9.55429H4.95864Z",
    fill: "black",
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54163 11.8V10.9086H7.47454V11.8H6.54163ZM6.54163 8.89429V8.00286H7.47454V8.89429H6.54163Z",
    fill: "black",
    stroke: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8312 7L10.9072 7.9H9.16574L8.24172 7H11.8312ZM11.8312 13H8.24172L9.16574 12.1086H10.9072L11.8312 13ZM8.98805 10.7286V11.9371L8.06403 12.8286V10.5057L8.41053 10.1714L8.98805 10.7286ZM8.06403 9.49429V7.17143L8.98805 8.06286V9.27143L8.41053 9.83714L8.06403 9.49429ZM12 10.5057V12.8286L11.076 11.9371V10.7286L11.6535 10.1714L12 10.5057ZM11.076 9.27143V8.06286L12 7.17143V9.49429L11.6535 9.83714L11.076 9.27143ZM11.0227 9.55429L11.4847 10L11.0227 10.4457H9.05024L8.58823 10L9.05024 9.55429H11.0227Z",
    fill: "black",
    stroke: "none"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoyaltyWatch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loyalty-watch.321c028d.svg";
export { ForwardRef as ReactComponent };